var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisplayed && _vm.getPercentage > 0)?_c('div',{staticClass:"price-savings",class:{ is21: _vm.is21 }},[(_vm.is21)?_c('span',[_vm._v("\n    "+_vm._s(_vm.$t('price-savings.savings'))+" "+_vm._s(`${_vm.getPercentage} %`)+"\n  ")]):_c('span',[_vm._v(_vm._s(`-${_vm.getPercentage} %`))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }